export const mediaGermanLocalization = {
  components: {
    'avatar-with-menu': {
      select: 'Bild aus Bibliothek auswählen',
      take: 'Foto aufnehmen',
      delete: 'Löschen',
      warnings: {
        nonSquareAspectRatio:
          'Quadratische Bilder werden in der App am besten dargestellt.'
      }
    },
    'media-menu': {
      document: 'Anhang auswählen',
      select: 'Bild aus Bibliothek auswählen',
      take: 'Foto aufnehmen',
      alerts: {
        document: {
          size: {
            title: 'Datei zu groß',
            content: 'Die Datei darf maximal {{maxFileSizeKb}} KB groß sein.',
            confirm: 'OK'
          }
        }
      }
    },
    'attachment-list': {
      uploadingPlaceholder: 'Datei wird hochladen...'
    }
  }
};

// Guarantees that both translations have the same structure
export const mediaEnglishLocalization: typeof mediaGermanLocalization = {
  components: {
    'avatar-with-menu': {
      select: 'Select image from library',
      take: 'Take a photo',
      delete: 'Delete',
      warnings: {
        nonSquareAspectRatio: 'Square images display best in the app.'
      }
    },
    'media-menu': {
      document: 'Select attachment',
      select: 'Select image from library',
      take: 'Take a photo',
      alerts: {
        document: {
          size: {
            title: 'File too big',
            content: 'File size must not exceed {{maxSizeKb}} KB.',
            confirm: 'OK'
          }
        }
      }
    },
    'attachment-list': {
      uploadingPlaceholder: 'File is uploading...'
    }
  }
};
